import * as CartService from '../services/CartService'

export const UPLOAD_FILE_TO_DATA_REQUEST = 'UPLOAD_FILE_TO_DATA_REQUEST';
export const UPLOAD_FILE_TO_DATA_SUCCESS = 'UPLOAD_FILE_TO_DATA_SUCCESS';
export const UPLOAD_FILE_TO_DATA_FAILURE = 'UPLOAD_FILE_TO_DATA_FAILURE';

export function uploadFileToDataRequest() {
    return {
        type: UPLOAD_FILE_TO_DATA_REQUEST
    }
}

export function uploadFileToDataSuccess(payload) {
    return {
        type: UPLOAD_FILE_TO_DATA_SUCCESS,
        payload
    }
}

export function uploadFileToDataFailure(payload) {
    return {
        type: UPLOAD_FILE_TO_DATA_FAILURE,
        payload
    }
}

export function uploadFileToData(file, fileName) {
    return (dispatch) => {
        dispatch(uploadFileToDataRequest());

        CartService.uploadFileToData(file, fileName)
            .then(response => {
                dispatch(uploadFileToDataSuccess(response));
            })
            .catch(error => {
                dispatch(uploadFileToDataFailure(error));
            });
    }
}
